export default function ({ url, galleryOptions, isDisabled }) {
    return {
        notify: [],
        showItemNotify: [],
        duration: 2000,
        galleryWithThumbnail: JSON.parse(galleryOptions).length > 1,
        init() {
            window.require(['domReady!'], () => {
                if (url.length > 0 && !isDisabled) {
                    try {
                        fetch(url, {
                            method: 'GET',
                            cache: 'no-store'
                        })
                            .then((response) => response.json())
                            .then((data) => {
                                if (data) {
                                    data.forEach((el, index) => {
                                        this.showItemNotify[index] = false;
                                    });

                                    this.notify = data;

                                    const countNotify =
                                        this.showItemNotify.length - 1;
                                    this.showItemNotify.forEach((el, index) => {
                                        this.visibilityNotify(
                                            index,
                                            true,
                                            countNotify * this.duration
                                        );
                                    });
                                }
                            });
                    } catch (error) {
                        console.error(error);
                    }
                }
            });
        },
        visibilityNotify(index, isShow, duration) {
            let time = null;
            clearTimeout(time);
            time = setTimeout(() => {
                this.showItemNotify[index] = isShow;
            }, duration - index * this.duration);
        }
    };
}
